import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "./AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Lock } from "lucide-react";
import { BUSINESS } from "../data/site";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin", { replace: true });
    else setError(res.error);
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center px-5 font-body">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        className="w-full max-w-md"
      >
        <div className="flex items-center gap-3 mb-8">
          <img src={BUSINESS.logo} alt="Patolas" className="h-11 w-auto object-contain bg-white rounded-md p-1" />
          <span className="font-display font-bold text-lg tracking-tight">Área de Gestão</span>
        </div>

        <div className="bg-[#141414] border border-[#2a2a2a] rounded-xl p-8">
          <div className="flex items-center gap-2 mb-6 text-[#00B4D8]">
            <Lock size={18} />
            <span className="font-body text-sm">Acesso restrito</span>
          </div>
          <h1 className="font-display font-black text-3xl tracking-tight mb-1">Iniciar sessão</h1>
          <p className="text-[#a3a3a3] text-sm mb-6">Fichas de clientes da Patolas.</p>

          <form onSubmit={submit} className="space-y-4" data-testid="login-form">
            <div className="space-y-1.5">
              <Label htmlFor="email" className="text-white">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="login-email"
                className="bg-[#0A0A0A] border-[#2a2a2a] text-white"
                placeholder="admin@patolas.pt"
              />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="password" className="text-white">Palavra-passe</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="login-password"
                className="bg-[#0A0A0A] border-[#2a2a2a] text-white"
                placeholder="••••••••"
              />
            </div>
            {error && (
              <p data-testid="login-error" className="text-sm text-[#E20074]">{error}</p>
            )}
            <Button
              type="submit"
              disabled={loading}
              data-testid="login-submit"
              className="w-full bg-[#E20074] hover:bg-[#c00063] text-white font-medium"
            >
              {loading ? "A entrar…" : "Entrar"}
            </Button>
          </form>
        </div>
        <a href="/" className="block text-center text-[#a3a3a3] text-sm mt-6 hover:text-white transition-colors">
          ← Voltar ao site
        </a>
      </motion.div>
    </div>
  );
}
